import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { callFrameSubject } from '../../index';
import './call-frame.style.scss';
const Render = ({ Component, Props }) => <Component {...Props}/>;
export const CallFrame = ({ className }) => {
    const [isOpen, setOpen] = useState(false);
    const [callFrameBody, setCallFrameBody] = useState({ component: null });
    const [callFrameBodyProps, setCallFrameBodyProps] = useState(null);
    useEffect(() => {
        const callFrameSubscription = callFrameSubject.subscribe((callFrameComponent) => {
            setOpen(!!callFrameComponent);
            if (callFrameComponent) {
                if (callFrameComponent.hasOwnProperty('component')) {
                    setCallFrameBody({
                        component: callFrameComponent.component,
                    });
                    setCallFrameBodyProps(null);
                }
                if (callFrameComponent.hasOwnProperty('props')) {
                    setCallFrameBodyProps(callFrameComponent.props);
                }
            }
        });
        return () => {
            callFrameSubscription.unsubscribe();
        };
    }, []);
    if (!callFrameBody.component || !isOpen)
        return null;
    return (<div className={classnames('extensions__call-frame', className)}>
      <div className="call-frame__wrapper">
        {Render({
            Component: callFrameBody.component,
            Props: callFrameBodyProps,
        })}
      </div>
    </div>);
};
